import script from "./NoAuth.vue?vue&type=script&setup=true&lang=js"
export * from "./NoAuth.vue?vue&type=script&setup=true&lang=js"

import "./NoAuth.vue?vue&type=style&index=0&id=5c254594&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5c254594"]])

export default __exports__
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QBtn});
